import { render, staticRenderFns } from "./mall_config.vue?vue&type=template&id=693f1a23&scoped=true"
import script from "./mall_config.vue?vue&type=script&lang=js"
export * from "./mall_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693f1a23",
  null
  
)

export default component.exports